import {
  buildDeliveryHistoryTooltip,
  getDeliveryStatusClass,
  parsePLDate
} from './ProductionCommon';

export { getDeliveryStatusClass, parsePLDate };

export const isDelayed = (item) => {
  const today = new Date();
  const estimatedDate = parsePLDate(item.estimated_delivery_date);
  if (estimatedDate) {
    return today > estimatedDate;
  }
  return false;
};

// ─── Helper to build tooltip for delivery date history ───
export const getDeliveryHistoryTooltip = (item) =>
  buildDeliveryHistoryTooltip(item, item.original_delivery_date);
